<template>
  <div class="exchange-success">
    <div class="container">
      <div class="exchange-success-content">
        <i class="el-icon-check"></i>
        <div class="info">
          <div class="title">恭喜您，兑换成功！</div>
          <div class="score">
            兑换积分：
            <span>{{detail.score*(this.$route.query.amount||1)}}积分</span>
          </div>
          <div class="name">
            兑换商品：
            <span>{{detail.title}} x {{this.$route.query.amount||1}}</span>
          </div>
          <div>
            <el-button
              type="primary"
              style="width:120px;margin-right:20px;"
              @click="goPath('/student/myIntegral/myExchange')"
            >兑换记录</el-button>
            <el-button
              type="primary"
              plain
              style="width:120px;"
              @click="goPath('/student/myIntegral/integralExchange')"
            >继续逛逛</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"])
  },
  methods: {
    goPath(path) {
      location.href = path;
    },
    exchangeGoods() {
      this.$http
        .post("/api/web/score/exchangeGoods", {
          id: this.$route.query.id,
          type: this.$route.query.type
        })
        .then(json => {
          this.detail = json.data;
        });
    }
  },
  mounted() {
    this.exchangeGoods();
  }
};
</script>

<style lang="scss" >
.exchange-success {
  background-color: #f5f6f9;
  height: calc(100vh - 152px);
  min-height: 490px;
  padding: 40px 0 80px 0;
  div.container {
    width: 1000px;
    background-color: #fff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    height: 300px;
    margin-top: 80px;
    .exchange-success-content {
      width: 500px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin: 0 auto;
      margin-top: 30px;
      .el-icon-check {
        font-size: 50px;
        border-radius: 50%;
        padding: 10px;
        font-weight: 600;
        color: #fff;
        background-color: #67c23a;
        margin-right: 40px;
      }
      .info {
        .title {
          font-weight: 700;
          font-size: 22px;
          margin-bottom: 20px;
        }
        .score {
          font-size: 16px;
          color: #6e6969;
          span {
            color: #f56c6c;
            padding-right: 20px;
          }
        }
        .name {
          font-size: 16px;
          color: #6e6969;
          margin: 10px 0 30px 0;
          span {
            color: #000000;
            padding-right: 20px;
          }
        }
      }
    }
  }
}
</style>


